module.exports = __webpack_public_path__ + "images/emoji/tennis.b886c28de6afc85494a0.png";